import { Component, Input, OnInit } from '@angular/core'

@Component({
    selector: 'app-custom-product-grid-item',
    templateUrl: './custom-product-grid-item.component.html',
    styleUrls: ['./custom-product-grid-item.component.scss'],
    standalone: false
})
export class CustomProductGridItemComponent implements OnInit {
  @Input() product: any
  constructor() {}

  ngOnInit(): void {}
}
